import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d56f0e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entity" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("确认")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, { class: "the-form" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "输入新密码" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "password",
              modelValue: _ctx.newPassword,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPassword) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, { label: "重复新密码" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              type: "password",
              modelValue: _ctx.repeat,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.repeat) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              onClick: _ctx.onConfirm,
              type: "primary",
              disabled: _ctx.newPassword === '' || _ctx.newPassword !== _ctx.repeat
            }, {
              default: _withCtx(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["onClick", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}